interface Config {
  API_BASE_URL: string;
}

const configuration: Record<string, Config> = {
  development: {
    API_BASE_URL: "http://localhost:8010/docx-core",
  },
  staging: {
    API_BASE_URL:
      "https://staging.backend.leadconnectorhq.com/docx-core",
  },
  interop: {
    API_BASE_URL:
      "https://staging.backend.leadconnectorhq.com/docx-core",
  },
  beta: {
    API_BASE_URL:
      "https://backend.leadconnectorhq.com/docx-core",
  },
  production: {
    API_BASE_URL:
      "https://backend.leadconnectorhq.com/docx-core",
  },
};

const fallback: Config = {
  API_BASE_URL: "http://localhost:8010/docx-core",
};

const env = import.meta.env.MODE || "development";
export const config: Config = {
  ...fallback,
  ...(configuration[env] ?? {}),
  ...(import.meta.env.VITE_API_BASE_URL
    ? { API_BASE_URL: import.meta.env.VITE_API_BASE_URL }
    : {}),
};
